import {fromEvent, share, Subject} from 'rxjs';

import {inject, Injectable, NgZone} from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class GlobalClickerService {
	public readonly globalClicker: Subject<MouseEvent> = new Subject<MouseEvent>();
	public readonly globalCtxMenuClicker: Subject<MouseEvent> = new Subject<MouseEvent>();
	private readonly ngZone: NgZone = inject(NgZone);

	constructor() {
		this.ngZone.runOutsideAngular(() => {
			fromEvent(window, 'click', {capture: true})
				.pipe(share())
				.subscribe((event: MouseEvent) => {
					this.ngZone.run(() => this.globalClicker.next(event));
				});

			fromEvent(window, 'contextmenu', {capture: true})
				.pipe(share())
				.subscribe((event: MouseEvent) => {
					this.ngZone.run(() => this.globalCtxMenuClicker.next(event));
				});
		});
	}
}
